/* eslint-disable no-shadow */
/* eslint-disable no-nested-ternary */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import NumberAutocomplete from '../../NumberAutocomplete';
import {
  getAssignedNumbers,
  modifyEditStatus,
  unassingVmailNumber,
} from '../../../actions/EpikBoxes';
import Toggle from '../../Toggle';
import getObiData from '../../../containers/epikBoxes/helpers';
import { disableAction } from '../../../actions/BoxSessionLogging';
import InfoPopup from '../../InfoPopup';
import { TOOLTIPS_TEXT } from '../../../lib/constants';
import { isAdminRole } from '../../../lib/utils';
import ConfirmationModal from '../../ConfirmationModal';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import { PIN_CODES_NAME } from '../../../utils/constants';
const PortProperty = ({
  label,
  editable,
  hidden,
  value,
  port,
  prop,
  editing,
  onEditPropertyKeyPress,
  user,
  deleteMode,
  assignedNumbers,
  onSelectNumber,
  onAddNewNumber,
  boxDetails,
  unassingVmailNumber,
  onOutsideClick,
  handleFwdToggle,
  disableAction,
  forceFix,
  modifyEditStatus,
  modifyStatus,
  disabled,
  callWaitingToggle
}) => {
  const token = localStorage.getItem('jwtToken');
  const propertyValue = value ? value(port[prop]) : port[prop] || '';
  const monitorVal = port.monitored;
  const inputRef = useRef();
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });

  useEffect(() => {
    if (inputRef.current && editing) {
      inputRef.current.focus();
    }
  }, [editing]);
  const [val, setVal] = useState(propertyValue);
  const [serviceName, setServiceName] = useState(port?.assignedNumberRef?.type || 'Unassigned');
  const [assignedNumber, setAssignedNumber] = useState(propertyValue);
  const [vmailLine, setVmailLine] = useState(propertyValue);
  const [monitoredVal, setMonitoredVal] = useState(monitorVal);
  const [found, setFound] = useState(false);
  const [loading, setLoading] = useState(true);
  useMemo(async () => {
    await getAssignedNumbers(token, boxDetails.assignedTo._id, boxDetails.epikBoxUser._id, false);
  }, []);
  useEffect(() => {
    setVal(propertyValue);
    setMonitoredVal(monitorVal);
  }, [propertyValue, monitorVal]);

  const getNumberList = async () => {
    setLoading(true);
    assignedNumbers.forEach(item => {
      if (port.assignedNumberRef && port.assignedNumberRef.number) {
        if (port.assignedNumberRef.number === item.number) {
          setAssignedNumber({ suggestion: item });
          setFound(true);
        }
      } else if (assignedNumber === item.number) {
        setAssignedNumber({ suggestion: item });
        setFound(true);
      } else {
        setFound(true);
      }
    });
    setLoading(false);
  };

  useMemo(() => {
    if (found) forceFix(false);
    else forceFix(true);
  }, [found]);

  const setVmailLineToUpdate = async () => {
    setLoading(true);
    assignedNumbers.forEach(item => {
      if (port?.vmNumber) {
        if (port.vmNumber === item.number) {
          setVmailLine({ suggestion: item });
          setFound(true);
        }
      } else if (vmailLine === item.number) {
        setVmailLine({ suggestion: item });
        setFound(true);
      } else {
        setFound(true);
      }
    });
    setLoading(false);
  };

  useEffect(() => {
    getNumberList();
    if (port?.vmNumber) {
      setVmailLineToUpdate();
    }
  }, [assignedNumbers]);

  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
     // Delay for 1 second before proceeding
     await new Promise(resolve => setTimeout(resolve, 1000));
     // Call onModify function
     await onModify();
 
  };
  const onModify = () => {
    global.vmail = false;
    // eslint-disable-next-line no-unused-expressions
    if (port?.assignedNumberRef?.number && assignedNumber !== '') {
      modifyEditStatus(true);
      onSelectNumber(assignedNumber);
    } else {
      modifyEditStatus(false);
      onAddNewNumber(true);
    }
  };
  const [callWaiting, setCallWaiting] = useState(port?.callWaiting)
  const [warningModal, setWarningModal] = useState(false)
  const [securityModal, setSecurityModal] = useState(false)
  return (
    <Col md={12}>
      {label === 'Status' ? (
        <FormGroup row>
          <Label for="showCallRecording" sm={8}>
            {label}:
          </Label>
          <Col md={12}>{val}</Col>
        </FormGroup>
      ) : label === 'Assigned Number' ? (
        <>
          <FormGroup row>
            <Row style={{ margin: '0px' }}>
              <Label for="name" sm={8}>
                Assigned Number:
              </Label>
              <Col sm={12}>
                {!loading && assignedNumbers.length !== 0 ? (
                  <NumberAutocomplete
                    searchTerm={
                      (port.assignedNumberRef && port.assignedNumberRef.number) ||
                      'No number assigned'
                    }
                    isDisabled
                    placeholder="Select Number"
                    numbers={assignedNumbers}
                    onChange={e => {
                      if (e.suggestion !== null) {
                        {/* e.suggestion?.linkedBox is a replacement of linkedToObi */}
                        if (e.suggestion?.linkedBox) {
                          toast.error('Number already assigned to an Epikbox');
                        } else {
                          setServiceName(e.suggestion.type);
                          setAssignedNumber(e);
                          onEditPropertyKeyPress({
                            target: { name: 'assignedNumber', value: e.suggestion.number },
                          });
                          onEditPropertyKeyPress({
                            target: { name: 'serviceName', value: e.suggestion.type },
                          });
                          onEditPropertyKeyPress({
                            target: { name: 'assignedNumberRef', value: e.suggestion._id },
                          });
                        }
                      }
                    }}
                  />
                ) : (
                  <Alert colSpan={2} color="info" className="price-not-found-alert">
                    {!loading ? 'No Number(s) found' : 'Loading, Please wait'}
                  </Alert>
                )}
              </Col>
              {!isAdminRole(user.role) && !modifyStatus && (
                <div style={{ display: 'flex' }}>
                  <div
                    hidden={!found}
                    onClick={disabled ? () => ({}) : () => {
                      const divElement = document.getElementById('test-time-remaining');
                      const isHidden = divElement.getAttribute('hidden') !== null;
                      if (isHidden) {
                        setDcUpdatePopup({ show: true });
                      } else {
                        onModify();
                      }

                    }}
                    style={{
                      cursor: 'pointer',
                      margin: '10px 0px 0px 18px',
                    }}
                    id="test-modify-btn"
                  >
                    <FontAwesomeIcon
                      icon="edit"
                      size="sm"
                      color="#29a4ff"
                      style={{ marginRight: '0.3rem' }}
                    />
                    Modify
                  </div>
                </div>
              )}
            </Row>
          </FormGroup>
          <FormGroup
            row
            hidden={
              boxDetails.myEpik ||
              (port?.assignedNumberRef?.type !== 'voice' &&
                port?.assignedNumberRef?.type !== 'hunt')
            }
          >
            <Label for="name" sm={8}>
              Enable voice mail:
            </Label>
            <Col md={12} className="d-flex">
              <Toggle
                value={!!port?.vmNumber}
                onToggle={async e => {
                  global.vmail = true;
                  if (e) {
                    const obiId = getObiData(port?.boxPortNumber, boxDetails, '_id');
                    const reqBody = {
                      number: port?.vmNumber,
                      port: port?.portKey,
                      boxId: boxDetails._id,
                    };
                    const res = await unassingVmailNumber(token, obiId, reqBody);
                    if (res) {
                      disableAction(`VMail number ${port?.vmNumber} removed from port`);
                    }
                    onOutsideClick();
                  } else {
                    onAddNewNumber(true, 'vmail');
                  }
                }}
              />
              <span
                className="cursor-pointer vmail-number-label"
                onClick={() => {
                  global.vmail = true;
                  vmailLine !== ''
                    ? onSelectNumber(vmailLine, 'vmail')
                    : console.log('number not found');
                }}
              >
                {port?.vmNumber}
              </span>
            </Col>
            </FormGroup>   

            <FormGroup
              row
              hidden={
                boxDetails.myEpik ||
                (port?.assignedNumberRef?.type !== 'voice')
              }
            >
              <Label for="name" sm={8}>
                Call Waiting:
              </Label>
              <Col md={12} className="d-flex">
                <Toggle
                  value={callWaiting}
                  onToggle={() => setWarningModal(true)}
                />
              </Col>
            </FormGroup>
          {!boxDetails.myEpik && (
            <FormGroup row>
              <Label for="name" sm={12} className="d-flex">
                Forward Number:
                <sup>
                  <InfoPopup id="forward-number" text={TOOLTIPS_TEXT.FORWARD_NUMBER} />
                </sup>
              </Label>
              <Col md={12} className="d-flex">
                  <Toggle value={port?.assignedNumberRef?.isForwarded} onToggle={handleFwdToggle} disabled={disabled} />
                <span
                  hidden={!port?.assignedNumberRef?.isForwarded}
                  className="cursor-pointer vmail-number-label"
                  onClick={handleFwdToggle}
                >
                  {port?.assignedNumberRef?.forwardNumbers?.[0]}
                </span>
              </Col>
            </FormGroup>
          )}

          <FormGroup row>
            <Label for="name" sm={8}>
              Service Name:
            </Label>
            <Col md={12}>
              <Input
                disabled
                placeholder="Please specify"
                required
                type="text"
                value={serviceName}
              />
            </Col>
          </FormGroup>

          <FormGroup row>
            <Label for="name" sm={12}>
              Caller ID Name (CNAM) :
            </Label>
            <Col md={12}>
              <Input
                disabled
                placeholder="Please specify"
                required
                type="text"
                value={port?.assignedNumberRef?.callerIdName}
              />
            </Col>
          </FormGroup>

          {port?.callerIdOverride && (
            <FormGroup row>
              <Label for="name" sm={12}>
                Outbound Caller ID Override:
              </Label>
              <Col md={12}>
                <Input
                  disabled
                  placeholder="Please specify"
                  required
                  type="text"
                  value={port?.callerIdOverride}
                />
              </Col>
            </FormGroup>
          )}
        </>
      ) : label === 'Monitor' ? (
        <FormGroup row>
          <Label for="showCallRecording" sm={8}>
            {label}:
          </Label>
          <Col md={12} style={{ display: 'flex', alignItems: 'center' }}>
            <Toggle
              value={monitoredVal}
              onToggle={e => {
                if (user.role !== 'admin' && user.role !== 'companyGroupManager' && !deleteMode) {
                  onEditPropertyKeyPress({ target: { name: 'monitored', value: !e } });
                  setMonitoredVal(!e);
                } else {
                  console.log('not permitted');
                }
              }}
            />
            {monitoredVal ? 'Enabled' : 'Disabled'}
          </Col>
        </FormGroup>
      ) : label !== 'Service Name' &&
        label !== 'Status' &&
        label !== 'Assigned Number' &&
        label !== 'E911 Number' ? (
        <FormGroup row>
          <Label for="name" sm={8}>
            {label}:
          </Label>
          <Col md={12}>
            <Input
              disabled={!editable}
              placeholder="Please specify"
              required
              type="text"
              name={prop}
              value={val}
              onChange={e => {
                onEditPropertyKeyPress(e);
                setVal(e.currentTarget.value);
              }}
              onKeyUp={onEditPropertyKeyPress}
            />
          </Col>
        </FormGroup>
      ) : null}

      <ConfirmationModal
        isOpen={warningModal}
        onCancel={() => {
          setWarningModal(false)
        }}
        headerText={`Alert `}
        bodyText={` Are you sure you want to ${port.callWaiting ? 'Disable' : 'Enable'} call Waiting service.`}
        onConfirm={() => {
          setWarningModal(false)
          setSecurityModal(true)
        }}
        confirmBtnText={'Confirm'}
      />
      <AddSecurityCodeModal
        isOpen={securityModal}
        onCancel={() => {
          setSecurityModal(false)
        }}
        onConfirm={() => {
          setSecurityModal(false);
          callWaitingToggle();
        }}
        featureName={PIN_CODES_NAME.callWaiting}
      />
       <ConfirmationModal
        bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
        headerText={'Device Lock Required'}
        confirmBtnText={'Lock & Edit'}
        close={'No'}
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton('add');
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
    </Col>
  );
};
const mapDispatchToProps = dispatch => ({
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(getAssignedNumbers(token, cid, uid, priStatus)),
  modifyEditStatus: status => dispatch(modifyEditStatus(status)),
  unassingVmailNumber: (token, obiId, body) => dispatch(unassingVmailNumber(token, obiId, body)),
  disableAction: description => dispatch(disableAction(description)),
});
const mapStateToProps = state => ({
  assignedNumbers: state.AppState.obis.assignedNumbers || [],
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PortProperty);
